import { safeMutate } from "../../../utils/GeneralUtils";
import ChrCommonDateRange from "../../../utils/CustomObject/ChrCommonDateRange";
import { chronusStore } from "../../../chronusStore";
import genericConstants from "../../../../platform_common_constants/constants.json";
import { DATE_STRING_OPTIONS } from "../../../utils/Constants";
import { getComponentForKey as getWidgetForKey } from "../../specific/Widgets/utils";
import ChrMetric from "../PageUI/Compound/Metric/ChrMetric";
import { dateRangePickerFields } from "../Form/constants";
import ChrDashboardRecommendation from "../PageUI/Compound/ChrDashboardRecommendation";

const synchronousReducerAction = (reducerAction, uId, data) => {
  return (dispatch) => {
    return new Promise(resolve => {
      dispatch(reducerAction({
        uId: uId,
        data: data
      }));
      resolve();
    });
  };
};

export const updateStore = (dispatch, reducerAction, uId, data) => {
  return dispatch(synchronousReducerAction(reducerAction, uId, data));
};

export const getStore = () => chronusStore.getState();

export const resetFilter = (...params) => {
  return modifyConfig({ isApplied: false, appliedTime: 0 }, ...params);
};

export const applyFilter = (...params) => {
  return modifyConfig({ isApplied: true, appliedTime: Date.now() }, ...params);
};

export const modifyConfig = (newConfigs, data, locateConfigFunction = object => object) => {
  return safeMutate(data, draftData => {
    locateConfigFunction(draftData).isApplied = newConfigs.isApplied;
    locateConfigFunction(draftData).appliedTime = newConfigs.appliedTime;
  });
};

export const getListenAllFilterConfigsHelperFunctions = (filterStateKey) => {
  return [
    state => Object.keys(state[filterStateKey].form),
    (state, filterKey) => state[filterStateKey].form[filterKey].configs
  ];
};

export const getCommonDateRangeFields = (formData, allowedFields) => {
  const allowedDateRangeFields = allowedFields || dateRangePickerFields.ALL;
  const fromDate = allowedDateRangeFields.includes(dateRangePickerFields.FROM) && formData && formData?.from?.data?.value;
  const toDate = allowedDateRangeFields.includes(dateRangePickerFields.TO) && formData && formData?.to?.data?.value;
  return { allowedFields: allowedDateRangeFields, fromDate, toDate }
}

export const getCommonDateRangeWithPresetFilterValue = (filterState, filterKey, formKey) => {
  const formData = filterState[filterKey].data;
  const selectedPreset = getCommonDateRangeWithPresetFilterSelectedOption(filterState, filterKey, formKey);
  const { fromDate, toDate } = getCommonDateRangeFields(formData, selectedPreset.allowedFields);
  const commonDateRangeObject = new ChrCommonDateRange(fromDate, toDate, (selectedPreset && selectedPreset.value));
  return { [formKey]: commonDateRangeObject.getSubmitDateRangeString() };
};

export const getCommonDateRangeWithPresetFilterSelectedOption = (filterState, filterKey) => {
  const selectedOption = filterState[filterKey].data.presets.find(option => option.selected);
  return selectedOption;
};

export const getCommonDateRangeWithPresetFilterLabel = (filterState, filterKey) => {
  const selectedPreset = getCommonDateRangeWithPresetFilterSelectedOption(filterState, filterKey);
  if (selectedPreset && !selectedPreset.canEdit) {
    return { label: selectedPreset.label };
  }

  const formData = filterState[filterKey].data;
  const { fromDate, toDate } = getCommonDateRangeFields(formData, selectedPreset.allowedFields);
  const dateStringOptions = {
    year: DATE_STRING_OPTIONS.NUMERIC,
    month: DATE_STRING_OPTIONS.SHORT,
    day: DATE_STRING_OPTIONS.NUMERIC
  }
  const commonDateRangeObject = new ChrCommonDateRange(fromDate, toDate);

  return { label: commonDateRangeObject.getLocaleDateRangeString(dateStringOptions) }
};

export const getLabelAndCountFromChoiceList = (choices) => {
  if(choices) {
    const labels = choices.map(choice => choice.label);
    return { label: labels.join(genericConstants.COMMA_SEPERATOR), count: labels.length }
  } else {
    return { label: "", count: 0 }
  }
};

export const getLabelListFromChoiceList = (choices) => {
  return choices ? choices.map(choice => choice.label) : choices;
};

export const getRawLabelListFromChoiceList = (choices) => {
  return choices ? choices.map(choice => choice.rawLabel) : choices;
};

export const getLabelFromChoiceList = (choices) => {
  return choices ? choices.map(choice => choice.label).join(", ") : choices;
};

export const getLabelOrValueFromChoiceList = (choices, options = {}) => {
  if(options.labelAndCount)
    return getLabelAndCountFromChoiceList(choices);
  if (options.labelOnly)
    return getLabelFromChoiceList(choices);
  return choices ? choices.map(choice => choice.value) : choices;
};

export const getContentComponent = (content) => {
  switch (content.type) {
    case genericConstants.WIDGET: {
      return getWidgetForKey(content.uId);
    }
    case genericConstants.METRIC: {
      return ChrMetric;
    }
    case genericConstants.DASHBOARD_RECOMMENDATION: {
      return ChrDashboardRecommendation;
    }
  }
};

export const isAStandaloneComponent = (components) => {
  return (components.length === 1) && components.every(component => component.type === genericConstants.DASHBOARD_RECOMMENDATION)
}

export { genericConstants };

export const getHoverOptions = (content, additionalOptions = {}) => {
  return {
    role: 'tooltip',
    "data-toggle": "tooltip",
    "data-original-title": content,
    "data-desc": content,
    "aria-label": content,
    ...additionalOptions
  };
};

export const isMobileOrTablet = () => {
  return document.querySelector("body.body-small") ? true : false;
};

export const formatToISODate = date => {
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
};
